import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { FormCheckboxControl } from '@angular/forms/signals';
import { Color, Size } from '../common/types';

@Component({
  selector: 'lepi-checkbox',
  templateUrl: './checkbox.component.html',
  imports: [CommonModule],
})
export class Checkbox implements FormCheckboxControl {
  checked = model<boolean>(false);
  label = input<string>();
  color = input<Color>('primary');
  size = input<Size>('md');

  // Static class arrays for tree-shaking
  readonly colorClasses: Record<Color, { checkbox: string; border: string }> = {
    primary: {
      checkbox: 'checkbox-primary',
      border: 'border-primary',
    },
    secondary: {
      checkbox: 'checkbox-secondary',
      border: 'border-secondary',
    },
    accent: {
      checkbox: 'checkbox-accent',
      border: 'border-accent',
    },
    success: {
      checkbox: 'checkbox-success',
      border: 'border-success',
    },
    warning: {
      checkbox: 'checkbox-warning',
      border: 'border-warning',
    },
    error: {
      checkbox: 'checkbox-error',
      border: 'border-error',
    },
    info: {
      checkbox: 'checkbox-info',
      border: 'border-info',
    },
    neutral: {
      checkbox: 'checkbox-neutral',
      border: 'border-neutral',
    },
  };

  readonly sizeClasses: Record<Size, string> = {
    xs: 'checkbox-xs',
    sm: 'checkbox-sm',
    md: 'checkbox-md',
    lg: 'checkbox-lg',
    xl: 'checkbox-xl',
  };
}
